module.exports = __webpack_public_path__ + "static/media/sombra-inferior.8547fb0d.svg";